if ( typeof SameColourSlider !== 'function' ) {

	class SameColourSlider extends HTMLElement {

		constructor() {
			super();
			this._loaded = false;
		}

		connectedCallback() {
			// Fires on initial page load once everything else is done (so this
			// fetch doesn't compete with the gallery/critical resources), and
			// immediately on later insertions (e.g. after the PDP colour-swap
			// ajax swap, when the page is already long past "loaded").
			if ( document.readyState === 'complete' ) {
				this.load();
			} else {
				window.addEventListener('load', () => this.load(), { once: true });
			}
		}

		load() {

			if ( this._loaded ) return;
			this._loaded = true;

			const collectionHandle = this.dataset.collection;
			const colour = this.dataset.colour;
			const excludeHandle = this.dataset.excludeHandle;

			if ( ! collectionHandle || ! colour ) return;

			const url = `/collections/${collectionHandle}?filter.p.m.my_fields.colour_name=${encodeURIComponent(colour)}`;

			fetch(url)
				.then(response => {
					if ( ! response.ok ) throw new Error('Request failed');
					return response.text();
				})
				.then(html => {

					const parsed = new DOMParser().parseFromString(html, 'text/html');
					const grid = parsed.getElementById('CollectionProductGrid');
					if ( ! grid ) return;

					// Shopify's dynamic colour filter groups related tones (e.g.
					// filtering "Gold" also returns "Bronze"), so it's only used
					// here to narrow the candidate pool — the exact match is
					// verified client-side against each card's own colour.
					const matches = [...grid.querySelectorAll('[data-js-product-item]')].filter(card => {
						const link = card.querySelector('.product-item__special-link');
						const isCurrent = link && link.dataset.id === `${excludeHandle}__link`;
						return ! isCurrent && card.dataset.colourName === colour;
					});

					// Fisher-Yates: pick a random 10 rather than always the same
					// first page of matches.
					for ( let i = matches.length - 1; i > 0; i-- ) {
						const j = Math.floor(Math.random() * (i + 1));
						[matches[i], matches[j]] = [matches[j], matches[i]];
					}
					const cards = matches.slice(0, 10);

					if ( ! cards.length ) return;

					const trackHTML = cards
						.map(card => `<div class="site-box-content collection-slider-product-item product-holder">${card.outerHTML}</div>`)
						.join('');

					this.innerHTML = `
						<div class="custom-slider-disable site-box-container container--fullscreen box--can-stick" style="border:none">
							<div style="min-height: 15vh !important; padding-top: 0px; padding-bottom: 0px;" class="site-box box--big lap--box--small-fl-auto box--typo-big box--center-align box--top-align-if-first box--column-flow box__heading" data-order="0">
								<div class="site-box-content reduce-top-margin-if-first">
									<div><h2 class="title h1">${this.dataset.heading}</h2></div>
								</div>
							</div>
							<div class="site-box box--big lap--box--bigger box--typo-big box--center-align box--column-flow box--no-padding box__collection" data-order="1">
								<div>
									<css-slider data-options='{"selector":".collection-slider-product-item","navigation":false,"autoHeight":true,"watchCSS":true}' class="content-slider-mobile css-slider--simple-dots" style="display:block">
										${trackHTML}
									</css-slider>
								</div>
							</div>
						</div>
					`;

				})
				.catch(()=>{});

		}

	}

	if ( typeof customElements.get('same-colour-slider') == 'undefined' ) {
		customElements.define('same-colour-slider', SameColourSlider);
	}

}
